import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import About from "./pages/about.js"
// import Blog from "./pages/blog.js"
import Contact from "./pages/contact.js"
import Faq from "./pages/faq.js"
import Home from './pages/index'
import Index2 from "./pages/index-2.js"
import IndexOne from "./pages/index-one.js"
import IndexTwo from "./pages/index-two.js"
import NewsDetails from "./pages/Why-WPC-Doors-Are-the-Future-of-Indian-Homes.js"
import NewsGrid from "./pages/blogs.js"
import News from "./pages/news.js"
import Pricing from "./pages/pricing.js"
import ProjectDetails from "./pages/project-details.js"
import Project from "./pages/project.js"
import ServiceDetails from "./pages/Wpc-Door-Frames.js"
import Service from "./pages/service.js"
import TeamDetails from "./pages/team-details.js"
import Team from "./pages/team.js"
import NotFound from "./pages/404.js"
import WpcDoors from "./pages/Wpc-Doors.js"
import WpcDoorFrames from "./pages/Wpc-Door-Frames.js"
import WpcFoamBoard from "./pages/Wpc-Foam-Board.js"
import WpcUVDigitalSeries from "./pages/Wpc-UV-Digital-Series.js"
import WpcPrintedDoors from "./pages/Wpc-Printed-Doors.js"
import DecorativeDoors from "./pages/Decorative-Doors.js"
import BlogDetails1 from "./pages/blog-details-1.js"
import BlogDetails2 from "./pages/WPC-vs-Wooden-Doors -What-Should-You-Choose.js"
import BlogDetails3 from "./pages/How-To-Choose-the-Right-WPC-Door-Frame .js"
import DealersAndDistribution from "./pages/dealers-and-distribution.js"
import Sustainability from "./pages/Sustainability.js"


export default function MainRouter() {
	return (
		<>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/about" element={<About />} />
					{/* <Route path="/blog" element={<Blog />} /> */}
					<Route path="/contact" element={<Contact />} />
					<Route path="/faq" element={<Faq />} />
					<Route path="/index-2" element={<Index2 />} />
					<Route path="/index-one" element={<IndexOne />} />
					<Route path="/index-two" element={<IndexTwo />} />
					<Route path="/Why-WPC-Doors-Are-the-Future-of-Indian-Homes" element={<NewsDetails />} />
					<Route path="/blogs" element={<NewsGrid />} />
					<Route path="/news" element={<News />} />
					<Route path="/pricing" element={<Pricing />} />
					<Route path="/project-details" element={<ProjectDetails />} />
					<Route path="/project" element={<Project />} />
					<Route path="/service-details" element={<ServiceDetails />} />
					<Route path="/service" element={<Service />} />
					<Route path="/team-details" element={<TeamDetails />} />
					<Route path="/team" element={<Team />} />
					<Route path="/Wpc-Doors" element={<WpcDoors />} />
					<Route path="/Wpc-Door-Frames" element={<WpcDoorFrames />} />
					<Route path="/Wpc-Foam-Board" element={<WpcFoamBoard />} />
					<Route path="/Wpc-UV-Digital-Series" element={<WpcUVDigitalSeries />} />
					<Route path="/Wpc-Printed-Doors" element={<WpcPrintedDoors />} />
					<Route path="/Decorative-Doors" element={<DecorativeDoors />} />
					<Route path="/404" element={<NotFound />} />
					<Route path="/blog-details-1" element={<BlogDetails1 />} />
					<Route path="/WPC-vs-Wooden-Doors-What-Should-You-Choose" element={<BlogDetails2 />} />
					<Route path="/How-To-Choose-the-Right-WPC-Door-Frame" element={<BlogDetails3 />} />
					<Route path="/dealers-and-distribution" element={<DealersAndDistribution />} />
					<Route path="/Sustainability" element={<Sustainability />} />
					{/* <Route path="/imgsec1" element={<imgsec1 />} /> */}
					
				</Routes>
		</>
	)
}
